import { trackEvent } from '~/features/analytics/track-event';
import type { ExperienceAtfPromoVariant } from '~/features/experience/constants';
import {
  type July4848PromoVariant,
  getJuly4848PromoCheckoutHref,
  JULY_48_48_PROMO_CTA_LABEL,
  JULY_48_48_PROMO_EYEBROW,
  JULY_48_48_PROMO_VARIANTS,
} from '~/features/promotions/constants/july-48-48-promo';

import type { PromoCampaignSurfaceRenderers } from '../types';

import { July4848PromoBanner } from './july-48-48-promo-banner';
import { July4848PromoCard } from './july-48-48-promo-card';

const JULY_48_48_PROMO_ANALYTICS_LABEL = 'july_48_48_sale_clicked';

/**
 * The experience ATF card renderer branches on `promoVariant` for palette/CTA/decoration.
 * `july_48_48_g1` / `july_48_48_g2` are the 48/48 July Flash Promo variants (blue→purple gradient,
 * outlined circled arrow-right CTA); G1 and G2 ship different "48" background art.
 */
const JULY_48_48_PROMO_ATF_VARIANT: Record<July4848PromoVariant, ExperienceAtfPromoVariant> = {
  g1: 'july_48_48_g1',
  g2: 'july_48_48_g2',
};

export const july4848PromoCampaignSurfaces: PromoCampaignSurfaceRenderers<July4848PromoVariant>['surfaces'] = {
  homepage: ({ resolved, promoCode, imagePriority }) => (
    <July4848PromoCard
      imagePriority={imagePriority}
      promoCode={promoCode}
      variant={resolved}
      onClick={() =>
        trackEvent({
          type: 'click',
          name: 'Homepage CTA Clicked',
          label: JULY_48_48_PROMO_ANALYTICS_LABEL,
        })
      }
    />
  ),
  catalog: ({ resolved, promoCode, imagePriority }) => (
    <July4848PromoBanner
      imagePriority={imagePriority}
      promoCode={promoCode}
      variant={resolved}
      onCtaClick={() =>
        trackEvent({
          type: 'click',
          name: 'Catalog Page CTA Clicked',
          label: JULY_48_48_PROMO_ANALYTICS_LABEL,
        })
      }
    />
  ),
  experience: ({ resolved, promoCode }) => {
    const config = JULY_48_48_PROMO_VARIANTS[resolved];
    return {
      id: JULY_48_48_PROMO_ATF_VARIANT[resolved],
      promoVariant: JULY_48_48_PROMO_ATF_VARIANT[resolved],
      eyebrow: JULY_48_48_PROMO_EYEBROW,
      title: config.headlineLine1,
      titleLine2: config.headlineLine2,
      description: config.subtitle,
      ctaLabel: JULY_48_48_PROMO_CTA_LABEL,
      action: {
        type: 'link',
        href: getJuly4848PromoCheckoutHref(resolved, promoCode),
      },
    };
  },
};
